import { render, staticRenderFns } from "./c-content-chart-village.vue?vue&type=template&id=189ee75a&"
import script from "./c-content-chart-village.vue?vue&type=script&lang=js&"
export * from "./c-content-chart-village.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports